const style=()=>({
    width: '100px',
    margin:'0 auto',
    padding:'10px'
})

export default style;